module.exports = __webpack_public_path__ + "img/green-counter-en.cab59e7c.png";